import { SiteInfo } from "@/globals";
import { BarChart3, ExternalLink, ShoppingBag, Tags } from "lucide-react";
import { useRouter } from "next/router";
import type React from "react";

type NavItem = {
  title: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
};

const navItems: NavItem[] = [
  { title: '대시보드', href: '/admin', icon: BarChart3 },
  { title: '주문 조회', href: '/admin/orders', icon: ShoppingBag },
  { title: '브랜드 관리', href: '/admin/brands', icon: Tags },
];

export default function AdminLayout({ children }: any) {
  const router = useRouter();

  return (
    <div className="min-h-screen bg-[#f7f4ef] text-[#101820]">
      <aside className="fixed inset-y-0 left-0 z-50 hidden w-64 border-r border-black/10 bg-white lg:block">
        <div className="flex h-full flex-col">
          <a href="/admin" className="flex h-[72px] items-center gap-3 border-b border-black/10 px-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#101820] text-base font-black text-white">P</span>
            <span className="min-w-0">
              <span className="block text-lg font-black leading-none">{SiteInfo.siteName}</span>
              <span className="mt-1 block text-xs font-semibold text-[#fd384f]">Admin</span>
            </span>
          </a>

          <nav className="grid gap-1 p-3" aria-label="관리자 메뉴">
            {navItems.map((item) => {
              const Icon = item.icon;
              const active = router.pathname === item.href;

              return (
                <a
                  key={item.href}
                  href={item.href}
                  className={`flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-bold transition ${active ? 'bg-[#101820] text-white' : 'text-gray-600 hover:bg-[#f7f4ef] hover:text-[#101820]'}`}
                >
                  <Icon className="h-4 w-4" />
                  {item.title}
                </a>
              );
            })}
          </nav>

          <div className="mt-auto grid gap-2 border-t border-black/10 p-3 text-sm font-semibold">
            <a href="https://prosense.co.kr" target="_blank" className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-gray-600 hover:bg-[#f7f4ef] hover:text-[#101820]">
              사이트 보기
              <ExternalLink className="h-4 w-4" />
            </a>
            <a href="https://portals.aliexpress.com/affiportals/web/home.htm" target="_blank" className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-gray-600 hover:bg-[#f7f4ef] hover:text-[#101820]">
              AliExpress Portals
              <ExternalLink className="h-4 w-4" />
            </a>
            <a href="https://openservice.aliexpress.com/app/index.htm#/app/overview?appkey=508970" target="_blank" className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-gray-600 hover:bg-[#f7f4ef] hover:text-[#101820]">
              App Console
              <ExternalLink className="h-4 w-4" />
            </a>
          </div>
        </div>
      </aside>

      <header className="sticky top-0 z-40 border-b border-black/10 bg-white/95 backdrop-blur lg:hidden">
        <div className="flex h-[64px] items-center gap-2 overflow-x-auto px-4">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = router.pathname === item.href;

            return (
              <a
                key={item.href}
                href={item.href}
                className={`inline-flex shrink-0 items-center gap-2 rounded-lg px-3 py-2 text-sm font-bold ${active ? 'bg-[#101820] text-white' : 'border border-black/10 bg-white text-gray-700'}`}
              >
                <Icon className="h-4 w-4" />
                {item.title}
              </a>
            );
          })}
        </div>
      </header>

      <main className="mx-auto min-h-screen max-w-[1280px] px-4 py-6 sm:px-6 lg:ml-64 lg:px-8">
        {children}
      </main>
    </div>
  );
}
